export class OMSContextSyncMessage {
    type: string;
    body: any;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}